export default __webpack_public_path__ + "static/media/chevron-down.ad357fd1.svg";